/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/VideoContentWithInteractiveEducation.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { InteractiveEducationLayout } from './InteractiveEducationLayout.migrated';
import { useInteractiveEducation } from '../hooks/useInteractiveEducation.migrated';
import { useInteractiveEducationProps } from '../hooks/useInteractiveEducationProps.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/VideoContentWithInteractiveEducation.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const VideoContentWithInteractiveEducation = ({
  lessonContentId,
  contentType,
  videoId,
  contentPortalId,
  videoTitle,
  interactiveContentTrackingProps,
  children,
  primaryContentId
}) => {
  const {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation,
    interactiveEducationEnabled
  } = useInteractiveEducation({
    videoId,
    interactiveContentTrackingProps
  });
  const interactiveEducationProps = useInteractiveEducationProps({
    primaryContentId,
    contentType,
    lessonContentId,
    videoId,
    contentPortalId,
    interactiveContentTrackingProps
  });
  return /*#__PURE__*/_jsx(InteractiveEducationLayout, {
    contentType: contentType,
    displayInteractiveEducation: displayInteractiveEducation,
    interactiveContentTrackingProps: interactiveContentTrackingProps,
    interactiveEducationEnabled: interactiveEducationEnabled,
    interactiveEducationProps: interactiveEducationProps,
    lessonContentId: lessonContentId,
    primaryContentId: primaryContentId,
    videoTitle: videoTitle,
    children: children({
      displayInteractiveEducation,
      handleDisplayInteractiveEducation,
      interactiveEducationEnabled,
      generateQuizLoading: interactiveEducationProps.generateQuizLoading
    })
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/VideoContentWithInteractiveEducation.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default VideoContentWithInteractiveEducation;